import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { StickyMobileCTA, FloatingWhatsApp } from "./components/StickyCTAs";
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import LocationDetail from "./pages/LocationDetail";
import ServiceLocation from "./pages/ServiceLocation";
import { ServicesIndex, LocationsIndex, ProjectsPage, BlogIndex, BlogPost } from "./pages/Pages";
import { ContactPage, QuotePage, AboutPage, FaqPage, PrivacyPage, TermsPage } from "./pages/MorePages";
import ProjectDetail from "./pages/ProjectDetail";
import SitemapPage from "./pages/SitemapPage";
import AdminApp from "./admin/AdminApp";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main className="min-h-[60vh]">{children}</main>
      <Footer />
      <StickyMobileCTA />
      <FloatingWhatsApp />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin (standalone — no public chrome) */}
          <Route path="/admin/*" element={<AdminApp />} />

          {/* Public site */}
          <Route path="/*" element={
            <PublicLayout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<ServicesIndex />} />
                <Route path="/services/:slug" element={<ServiceDetail />} />
                <Route path="/locations" element={<LocationsIndex />} />
                <Route path="/locations/:slug" element={<LocationDetail />} />
                <Route path="/projects" element={<ProjectsPage />} />
                <Route path="/projects/:slug" element={<ProjectDetail />} />
                <Route path="/blog" element={<BlogIndex />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/quote" element={<QuotePage />} />
                <Route path="/faq" element={<FaqPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/sitemap" element={<SitemapPage />} />
                <Route path="/:service/:location" element={<ServiceLocation />} />
                <Route path="*" element={<Home />} />
              </Routes>
            </PublicLayout>
          } />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
